module.exports = __webpack_public_path__ + "img/change_password.791f99e4.svg";